(() => {
    'use strict';

    real.events.on('transcript:updated', notification => {
        'use strict';

        const result = notification.object;
        const uploadedFileId = result.uploadedfile.id;
        const transcriptText = result.transcript.text || '';

        if (result.transcript.html && uploadedFileId.length > 0) {
            const transcriptContainer = $(`.transcript-container[data-uploadedfile-id="${uploadedFileId}"]`);
            if (transcriptContainer.length === 0) {
                return;
            }

            if (transcriptText.length === 0) {
                // If the transcript text is empty, hide the transcript container
                howspace.animate(transcriptContainer, 'slideUp', 350, () => {
                    transcriptContainer.addClass('d-none');
                });
            } else {
                howspace.animate(transcriptContainer, 'slideDown', 350, () => {
                    transcriptContainer.removeClass('d-none');
                });
            }

            const transcriptContainerContent = transcriptContainer.find('.card-content');
            transcriptContainerContent.html(result.transcript.html);
            howspace.transcript.init(transcriptContainerContent);
            howspace.components.translator.init(transcriptContainerContent);
        }
    });

})();
